<template>
  <div>
    <!-- Question-level complainability (always shown) -->
    <div class="form-group form-row">
      <label class="col-lg-4 col-md-6 col-form-label pt-0">
        {{ $t('Webportal.Question') }}
        <span v-b-tooltip.hover.nofade="toolTipDelay"
              :title="onlyQuestionsWithScoring
                ? $t('Webportal.Administration.QuestionComplainability.Question.DescriptionOnlyWithScoring')
                : $t('Webportal.Administration.QuestionComplainability.Question.Description')">
          <font-awesome-icon :icon="['fas', 'info-circle']" />
        </span>
      </label>
      <div class="col">
        <b-form-radio-group
          buttons
          button-variant="outline-secondary"
          size="sm"
          :checked="questionComplainability"
          @input="$emit('update:question-complainability', $event)"
          :disabled="disabled"
        >
          <b-form-radio :value="true">{{ $t('Webportal.Administration.QuestionComplainability.Complainable') }}</b-form-radio>
          <b-form-radio :value="false">{{ $t('Webportal.Administration.QuestionComplainability.NotComplainable') }}</b-form-radio>
        </b-form-radio-group>
      </div>
    </div>

    <!-- Answer-level complainability (only for choice questions, disabled when question not complainable) -->
    <div v-if="hasAnswers" class="form-group">
      <label>
        {{ $t('Webportal.Administration.QuestionComplainability.Answer') }}
        <span v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Administration.QuestionComplainability.Answer.Description')">
          <font-awesome-icon :icon="['fas', 'info-circle']" />
        </span>
      </label>
      <div v-for="answer in answers" :key="answer.ExternalSurveyAnswerId" class="form-row align-items-center mb-2">
        <div class="col-md-4">{{ answer.SurveyAnswerText }}</div>
        <div class="col">
          <b-form-radio-group
            buttons
            button-variant="outline-secondary"
            size="sm"
            :checked="answerComplainability[answer.ExternalSurveyAnswerId] ?? true"
            @input="$emit('update:answer-complainability', answer.ExternalSurveyAnswerId, $event)"
            :disabled="disabled || !isQuestionComplainable"
          >
            <b-form-radio :value="true">{{ $t('Webportal.Administration.QuestionComplainability.Complainable') }}</b-form-radio>
            <b-form-radio :value="false">{{ $t('Webportal.Administration.QuestionComplainability.NotComplainable') }}</b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";

export default {
  name: "QuestionComplainability",
  mixins: [AppConfig],

  props: {
    question: { type: Object, default: null },
    questionComplainability: { default: null },
    answerComplainability: { type: Object, default: () => ({}) },
    onlyQuestionsWithScoring: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },

  computed: {
    isQuestionComplainable() {
      return this.questionComplainability === true;
    },

    hasAnswers() {
      return !this.question?.IsCommentPossible && this.answers.length > 0;
    },

    answers() {
      return this.question?.Answers ?? [];
    },
  },
};
</script>
